import { Model } from "@/models";

export default class MatchProblemGroup extends Model {
  static type = "clientsAdcontrolMatchProblems";

  adcontrolProductId!: number;
  adcontrolProductName!: string;
  adcontrolCompanyIconUrl!: string;
  adcontrolCompanyIconColor!: string;
}
